import ListCard from '../ListCard';
import { H6, P, UL, LI, Btn, Image } from '../../../../../AbstractElements';
import JobDescription from './jobDescription';
import React, { Fragment } from 'react';
import { Card, Col, CardBody, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import i18n from '../../../../../i18n';

const MainCard = () => {
    return (
        <Fragment>
            <Col xl="9" className="box-col-8 xl-60">
                <Card>
                    <div className="job-search">
                        <CardBody>
                            <div className="media">
                                <Image attrImage={{ className: 'img-40 img-fluid m-r-20', src: ``, alt: '' }} />
                                <div className="media-body">
                                    <H6 attrH6={{ className: 'f-w-600' }} ><a href="#javascript">{i18n.t('Dashboard_ContractsReport_RoleTitle')}</a></H6>
                                    <P>{i18n.t('Dashboard_ContractsReport_CompanyLocation')}</P>
                                    <UL attrUL={{ className: 'rating simple-list' }} >
                                        <LI><i className="fa fa-star font-warning"></i></LI>
                                        <LI><i className="fa fa-star font-warning"></i></LI>
                                        <LI><i className="fa fa-star font-warning"></i></LI>
                                        <LI><i className="fa fa-star font-warning"></i></LI>
                                        <LI><i className="fa fa-star font-warning"></i></LI>
                                    </UL>
                                    <Link to={`${process.env.PUBLIC_URL}/dashboard/contracts`}>
                                        <Btn attrBtn={{ className: 'btn btn-sm job-apply-btn', color: 'primary' }}>{i18n.t('Dashboard_ContractsReport_Apply')}</Btn>
                                    </Link>
                                </div>
                            </div>
                            <JobDescription />
                        </CardBody>
                    </div>
                </Card>
                <div className="header-faq">
                    <H6 attrH6={{ className: 'mb-0 f-w-600' }}>{i18n.t('Dashboard_ContractsReport_Similar')}</H6>
                </div>
                <Row>
                  
                </Row>
            </Col >
        </Fragment >
    );
};

export default MainCard;
